// list of the items/blogs
export const blogList = [
  {
    dateTime: "01 June 2021",
    title:
      "Tesla Cybertruck-inspired camper trailer for Tesla fans who can’t just wait for the truck!",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 November 2020",
    title: "Whiteboard Templates By Industry Leaders",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "01 February 2020",
    title: "Designify Agency Landing Page Design",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "03 February 2020",
    title: "✨What is Done is Done ✨",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title: "Fresh Prince",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title: "Six Socks Studio",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title:
      "vincenzo de cotiis’ crossing over showcases a research on contamination",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title: "Simple, Great Looking Animations in Your Project | Video Tutorial",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title: "40 Free Serif Fonts for Digital Designers",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title: "Examining the Evolution of the Typical Web Design Client",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
  {
    dateTime: "05 February 2020",
    title: "Katie Griffin loves making that homey art",
    path: "#",
    social: { comment: "76.46k", views: "90.58k", share: "77.89k" },
  },
];
